export default {
  header: {
    marginBottom: '20px',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  },
  dates: {
    position: 'absolute',
    top: '0',
    right: '0',
    transform: 'translateX(-30px)',
    zIndex: 1,
  },
  title: {
    lineHeight: '33px',
    fontSize: '28px',
    padding: '0 50px',
  },
  cell: {
    fontSize: '12px',
    height: '30px',
    display: 'flex',
    whiteSpace: 'nowrap',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}
